import Vue from 'vue'
import Vuex from 'vuex'
import * as modules from '@store/modules'
import cache from 'vuex-cache'
import handler from 'vuex-handler'
import { onFailure, onSuccess } from '@store/handlers'
import persistence from 'vuex-localstorage'
import { name, version } from '@/../package'

Vue.use(Vuex)

const settings = {
  namespace: `${name}@${version}`,
  timeout: 2 * 24 * 60 * 60 * 1000
}

const store = new Vuex.Store({
  strict: process.env.STRICT_MODE,
  plugins: [ cache, handler, persistence(settings) ],
  modules
})

store.handler = { onFailure, onSuccess }

export default store



// WEBPACK FOOTER //
// ./src/store/index.js